// extracted by mini-css-extract-plugin
export default {"worksBlock":"works_worksBlock__TXPBK","worksContent":"works_worksContent__F4dSH"};